module.exports = __webpack_public_path__ + "img/logo1.d803ed58.png";